var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapJazz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3151)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#F557EF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3151)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3151",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 39,
    width: 35,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40,
    y: 39,
    width: 35,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 54.4089H69.5227C71.1491 52.9835 71.7686 50.6364 70.8935 48.5294L67.3698 49.9857C68.4385 48.0182 68.1365 45.5161 66.4792 43.8506L64.0242 46.3062C64.1249 44.1837 62.909 42.131 60.8335 41.2711L59.3853 44.757C58.7657 42.588 56.7677 41 54.4056 41V44.5556C52.9729 42.9831 50.6651 42.3943 48.5895 43.2542L49.9835 46.6316C48.0165 45.5626 45.515 45.8647 43.85 47.5224L46.4598 50.1329C44.3069 49.9935 42.2004 51.2174 41.333 53.3244L44.5857 54.6722C42.5024 55.3307 41 57.2827 41 59.5911H44.7948C43.091 61.001 42.425 63.4101 43.3156 65.5635L46.514 64.2389C45.5847 66.1678 45.9255 68.5536 47.5208 70.1494L50.2159 67.4536C49.9603 69.6923 51.1994 71.9155 53.3833 72.8218L54.7231 69.5839C55.4434 71.5747 57.3562 73 59.5944 73V69.2818C60.9961 71.0402 63.4434 71.7451 65.6273 70.8388L64.241 67.4924C66.1694 68.4219 68.5547 68.0811 70.15 66.4854L67.6176 63.9523C69.817 64.1537 71.9932 62.9221 72.8838 60.7763L69.4221 59.3355C71.4976 58.6616 73 56.7095 73 54.4089Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73 54.4089H69.5227C71.1491 52.9835 71.7686 50.6364 70.8935 48.5294L67.3698 49.9857C68.4385 48.0182 68.1365 45.5161 66.4792 43.8506L64.0242 46.3062C64.1249 44.1837 62.909 42.131 60.8335 41.2711L59.3853 44.757C58.7657 42.588 56.7677 41 54.4056 41V44.5556C52.9729 42.9831 50.6651 42.3943 48.5895 43.2542L49.9835 46.6316C48.0165 45.5626 45.515 45.8647 43.85 47.5224L46.4598 50.1329C44.3069 49.9935 42.2004 51.2174 41.333 53.3244L44.5857 54.6722C42.5024 55.3307 41 57.2827 41 59.5911H44.7948C43.091 61.001 42.425 63.4101 43.3156 65.5635L46.514 64.2389C45.5847 66.1678 45.9255 68.5536 47.5208 70.1494L50.2159 67.4536C49.9603 69.6923 51.1994 71.9155 53.3833 72.8218L54.7231 69.5839C55.4434 71.5747 57.3562 73 59.5944 73V69.2818C60.9961 71.0402 63.4434 71.7451 65.6273 70.8388L64.241 67.4924C66.1694 68.4219 68.5547 68.0811 70.15 66.4854L67.6176 63.9523C69.817 64.1537 71.9932 62.9221 72.8838 60.7763L69.4221 59.3355C71.4976 58.6616 73 56.7095 73 54.4089Z",
    fill: "#F557EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 54.4089H69.5227C71.1491 52.9835 71.7686 50.6364 70.8935 48.5294L67.3698 49.9857C68.4385 48.0182 68.1365 45.5161 66.4792 43.8506L64.0242 46.3062C64.1249 44.1837 62.909 42.131 60.8335 41.2711L59.3853 44.757C58.7657 42.588 56.7677 41 54.4056 41V44.5556C52.9729 42.9831 50.6651 42.3943 48.5895 43.2542L49.9835 46.6316C48.0165 45.5626 45.515 45.8647 43.85 47.5224L46.4598 50.1329C44.3069 49.9935 42.2004 51.2174 41.333 53.3244L44.5857 54.6722C42.5024 55.3307 41 57.2827 41 59.5911H44.7948C43.091 61.001 42.425 63.4101 43.3156 65.5635L46.514 64.2389C45.5847 66.1678 45.9255 68.5536 47.5208 70.1494L50.2159 67.4536C49.9603 69.6923 51.1994 71.9155 53.3833 72.8218L54.7231 69.5839C55.4434 71.5747 57.3562 73 59.5944 73V69.2818C60.9961 71.0402 63.4434 71.7451 65.6273 70.8388L64.241 67.4924C66.1694 68.4219 68.5547 68.0811 70.15 66.4854L67.6176 63.9523C69.817 64.1537 71.9932 62.9221 72.8838 60.7763L69.4221 59.3355C71.4976 58.6616 73 56.7095 73 54.4089Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3151",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3151"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3151",
    x: 36,
    y: 39.9649,
    width: 42.1904,
    height: 42.1642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3151",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapJazz);
export default __webpack_public_path__ + "static/media/glowing_map_jazz.b20fd484e07f268e251422fb820cc823.svg";
export { ForwardRef as ReactComponent };